import React from 'react';

import { Image } from 'shared/components/image/Image';
import footer from 'assets/footer.svg';

export const Footer = () => <Image alt="" src={footer} />;
